import { types, actions } from './requests'
export const GETMASTERLIST_TYPES = {
    ...types('GETMASTERLIST'),
}
export const GETMASTERLIST_ACTIONS = {
    ...actions('GETMASTERLIST'),
}